import React from "react";

import "./index.scss";

const DashboardIcon = props => (
  <svg
    id="Dashboard_Icon"
    data-name="Dashboard"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    className="dashboard-icon"
  >
    <g transform="translate(16 16)">
      <g id="Group_8769" data-name="Group 8769" transform="translate(-16 -16)">
        <path id="Path_8612" data-name="Path 8612" fill="none" d="M0,0H32V32H0Z" />
        <path
          id="Path_8613"
          data-name="Path 8613"
          className={`default ${props.active ? "active" : ""}`}
          d="M18.109,27.983V15.288h9.874V27.983ZM4,27.983V20.93h9.874v7.053ZM4,16.7V4h9.874V16.7Zm14.106-5.642V4h9.874v7.053Z"
        />
      </g>
    </g>
  </svg>
);

export default DashboardIcon;
